export default "__VITE_ASSET__CicZIySE__"